<script setup lang="ts">

import {useAuthentication} from "~/stores/authentication";
import {submitFeedback} from "~/calls/feedback";

const router = useRouter();
const {email} = useAuthentication()

const props = defineProps<{
  goal: string,
  toSlackMessage: (contactType: string, email: string, phone: string, comments: string, goal: string) => string
}>()


const contactType = ref<'email' | 'phone'>('email')
const emailValue = ref<string>(email || '')
const phoneValue = ref('')
const comments = ref('')
const formIsCompleted = ref(null)

const submitted = ref(false)
const loading = ref(false)

const form = ref(null as any)
const onSubmit = async () => {
  const validation = await form.value.validate()
  if (!validation.valid) {
    return
  }
  loading.value = true
  submitFeedback(
      props.toSlackMessage(contactType.value, emailValue.value, phoneValue.value, comments.value),
      window.location.href
  ).then((r) => {
    if (!r.success) return
    submitted.value = true
  }).finally(() => {
    loading.value = false
  })
}

const closeForm = () => {
  router.push({query: {}})
}
</script>
<template>
  <div>
    <div v-if="submitted">
      <v-alert type="success">
        <p>Thank you for contacting us. We will be in touch with you soon!</p>
      </v-alert>
      <v-btn color="primary" @click="closeForm" class="mt-2">Close</v-btn>
    </div>
    <v-form v-if="!submitted" v-model="formIsCompleted" ref="form" @submit.prevent="onSubmit">
      <div class="d-flex flex-column gap-2">
        <slot>
          <p>
            You want to get in touch with us about our {{ goal }}. How do you want to be contacted?
          </p>
        </slot>

        <v-radio-group inline v-model="contactType" class="mb-n6">
          <v-radio label="E-mail" value="email"/>
          <v-radio label="Phone" value="phone"/>

        </v-radio-group>

        <div>
          <span v-if="contactType === 'email'">We will contact you via E-mail. Is this the email you want to be contacted on? Feel free to change it.</span>
          <span v-if="contactType === 'phone'">We will contact you via Phone. What's your phone number?</span>
        </div>

        <v-text-field v-if="contactType === 'email'" :rules="[formRules.required]" v-model="emailValue" class="mt-2"/>
        <v-text-field v-if="contactType === 'phone'" :rules="[formRules.required]" placeholder="+919367788755"
                      v-model="phoneValue"
                      class="mt-2"/>

        <p>
          Do you have any additional comments?
        </p>

        <v-textarea v-model="comments"
                    placeholder="Let our team know anything you'd like us to know about your query here."/>

        <p class="mt-4 mb-2 text-end">
          <v-btn color="secondary" :disabled="!formIsCompleted" type="submit" :loading="loading">Submit request</v-btn>
        </p>
      </div>
    </v-form>
  </div>
</template>
